import { useState } from 'react';
import InvestorSidebar from '../components/sidebar/investorSidebar/InvestorSidebar';
import InvestorNav from '../components/navbar/investorNav/InvestorNav';
const Investor_web_portal = ({ children, title_props, ToggleBtn, language }) => {
  const [side, setSide] = useState('-left-64 md:left-0');
  console.log(side);
  const openSidebar = () => {
    setSide('left-0 md:-left-64');
  };
  const closeSidebar = () => {
    setSide('-left-64 md:left-0');
  };

  return (
    <>
      <InvestorSidebar side={side} closeSidebar={closeSidebar} />
      <InvestorNav
        title_props={title_props}
        openSidebar={openSidebar}
        language={language}
        closeSidebar={closeSidebar}
        ToggleBtn={ToggleBtn}
        side={side}
      />
      <section
        className={`ml-0 ${
          side === 'left-0 md:-left-64' ? 'ml-0 ' : 'ml-0 md:ml-64'
        }  bg-white min-h-screen md:px-4 px-0`}
      >
        <div className="  h-full text-black min-h-screen pt-32 bg-lightGray    px-4 py-6">
          {children}
        </div>
      </section>
    </>
  );
};
export default Investor_web_portal;
